import { Reveal } from "../../lib/animations";
import { PHOTOS } from "../../lib/site";

const TOPICS = ["Bellydance", "Motherhood", "Children's Education", "Travel", "Lifestyle"];

export const Magazine = () => {
  return (
    <section
      id="magazine"
      data-testid="magazine-section"
      className="relative overflow-hidden bg-champagne px-6 py-28 md:px-12 md:py-40"
    >
      {/* soft ambient wash */}
      <div className="pointer-events-none absolute right-0 top-1/4 h-[60%] w-[45%] bg-[radial-gradient(ellipse_at_center,rgba(228,120,98,0.18),transparent_65%)]" />

      <div className="relative mx-auto grid max-w-[1500px] grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-24">
        {/* Cover image */}
        <Reveal className="lg:col-span-6">
          <div className="group relative overflow-hidden rounded-[28px] border border-gold/40 shadow-[0_30px_80px_-30px_rgba(37,21,4,0.45)]">
            <img
              src={PHOTOS.magazineCover}
              alt="Cibele Magazine — Travel the world of Belly Dance"
              className="w-full object-cover transition-transform duration-[1000ms] ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:scale-[1.04]"
            />
          </div>
        </Reveal>

        {/* Text + CTA */}
        <div className="lg:col-span-6">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 font-sans text-[0.7rem] uppercase tracking-[0.34em] text-terracotta">
              <span className="h-px w-10 bg-gold" /> The Magazine
            </p>
            <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-espresso md:text-6xl">
              Unleash your spirit of{" "}
              <span className="italic text-plum">adventure</span>.
            </h2>
            <p className="mt-8 max-w-xl font-sans text-base leading-relaxed text-espresso/70">
              A quarterly magazine for the adventurous woman — stories on culture,
              movement, motherhood and life lived across borders. Available in
              English &amp; Dutch.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 flex flex-wrap gap-3">
              {TOPICS.map((t) => (
                <span
                  key={t}
                  data-testid={`magazine-topic-${t.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="rounded-full border border-espresso/25 px-4 py-2 font-sans text-[0.65rem] uppercase tracking-[0.2em] text-espresso/80 transition-colors duration-300 hover:border-plum hover:text-plum"
                >
                  {t}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <div className="mt-12 flex flex-col items-start gap-5 border-t border-espresso/15 pt-10 sm:flex-row sm:items-center sm:justify-between">
              <p className="font-serif text-xl italic text-espresso md:text-2xl">
                Join the Adventure&apos;s Women Club
              </p>
              <a
                href="https://traveltheworldofbellydance.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="magazine-shop-btn"
                className="group relative inline-flex items-center gap-3 overflow-hidden rounded-full bg-plum px-10 py-4 font-sans text-xs uppercase tracking-[0.26em] text-champagne"
              >
                <span className="absolute inset-0 -translate-x-full bg-terracotta transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:translate-x-0" />
                <span className="relative z-10">Shop Now</span>
                <span className="relative z-10 inline-block transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
